import { MyTransactions, Summary } from '@/views/MyCards'

const MyCardsPage: React.FC = () => {
  return (
    <div>
      <Summary />
      <MyTransactions />
    </div>
  )
}

export default MyCardsPage
